import React from 'react';
import clsx from 'clsx';
import { Typography } from '../typography';
import { StatusCase } from '@/interfaces';

export type TimelineProps = {
	name?: string;
	options: string[];
	totalSteps: number;
	disabled?: boolean;
	className?: string;
	defaultValue: number;
};

export const Timeline: React.FC<TimelineProps> = ({
	name,
	options,
	// totalSteps,
	disabled,
	className,
	defaultValue,
}) => {
	const separatePercentage = (1 / (options.length - 1)) * 100;
	const percentage = (Number(defaultValue) / (options.length - 1)) * 100;

	const calculateBackground = (): string => {
		let colorBackground = '';
		if (disabled) {
			colorBackground = `linear-gradient(to right, #616161 0%, #616161 ${percentage}%, #E8E8E8 ${percentage}%, #E8E8E8 100%)`;
		} else {
			colorBackground = `linear-gradient(to right, #2084E7 0%, #2084E7 ${percentage}%, #E8E8E8 ${percentage}%, #E8E8E8 100%)`;
		}
		return colorBackground;
	};

	const getCustomMargin = (status: StatusCase): string | undefined => {
		switch (status) {
			case 'Application in review':
			case 'Documents required':
			case 'Application approved':
			case 'Review complaint':
			case 'Case in progress':
			case 'Accept settlement':
				if (
					status === 'Application in review' ||
					status === 'Documents required' ||
					status === 'Application approved' ||
					status === 'Review complaint' ||
					status === 'Case in progress' ||
					status === 'Accept settlement'
				)
					return '-ml-12';
				break;
			case 'Sign retainer':
			case 'Case initiated':
			case 'Payment details':
				if (
					status === 'Sign retainer' ||
					status === 'Case initiated' ||
					status === 'Payment details'
				)
					return '-ml-10';
				break;
			case 'Review Demand Letter':
				return '-ml-16';
			case 'Case resolved':
				return 'whitespace-nowrap';

			default:
				break;
		}
	};

	return (
		<>
			<div className={clsx('relative h-24 max-w-[96%]', className)}>
				<div className="flex w-full justify-between">
					{options.map((option, index) => (
						<label key={option}>
							<div
								style={{
									left: `${
										index === options.length - 1
											? '96'
											: separatePercentage * index
									}%`,
								}}
								className={clsx(
									'flex flex-col absolute',
									index % 2 === 0 ? 'top-1' : 'bottom-3',
									getCustomMargin(option as StatusCase)
								)}
							>
								<Typography
									type="regular-12"
									className={clsx(
										'text-black',
										index === defaultValue
											? ' font-medium lg:font-semibold'
											: 'font-normal'
									)}
								>
									{option}
								</Typography>
							</div>
						</label>
					))}
				</div>
				{options.map((_, index) => (
					<div
						key={'cicle' + index}
						style={{ left: `${separatePercentage * index}%` }}
						className={clsx(
							'absolute w-5 h-5 rounded-full top-[34%] z-10',
							index > defaultValue
								? 'bg-grey-10'
								: disabled
								? 'bg-grey-70'
								: 'bg-main-blue',
							index > 0 ? '-ml-1' : ''
						)}
					/>
				))}
				{/* <Typography
					type="regular-14"
					className={clsx(
						'absolute -right-[50px] top-[34%]',
						getPercent(defaultValue, totalSteps) === 100
							? 'text-black'
							: 'text-opacity-black',
						router.pathname.includes('client-profile') ? 'hidden' : ''
					)}
				>
					{getPercent(defaultValue, totalSteps)}%
				</Typography> */}
				<input
					id="inputRange"
					name={name}
					type="range"
					min="1"
					max={options.length}
					step="1"
					className="w-full absolute bottom-1/2 outline-none [&::-moz-range-thumb]:appearance-none [&::-moz-range-thumb]:border-0 [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:opacity-0 [&::-moz-range-thumb]:opacity-0"
					value={defaultValue || 2}
					disabled={disabled}
					style={{
						background: calculateBackground(),
					}}
					readOnly
				/>
			</div>
		</>
	);
};
